<div class="iot-platform-ui-chat-message" fxLayout="column" fxLayoutGap="4px" [style]="message().customStyle?.()">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
    @if (message().icon?.()) {
      <mat-icon class="message-icon" [svgIcon]="$safeNavigationMigration(message().icon?.())" color="accent"></mat-icon>
    }
    @if (message().author?.()) {
      <span class="message-author">{{ message().author?.() }}</span>
    }
    @if (message().date?.()) {
      <span class="message-date">{{ $safeNavigationMigration(message().date?.()) | dateFormat }}</span>
    }
  </div>

  <div class="message-container">
    @if (message().text()) {
      <pre class="message-value" [innerHTML]="$safeNavigationMigration(message().text?.()) | linkify"></pre>
      @if (message().withActions?.()) {
        <div class="message-actions">
          @for (action of message().actions?.(); track action?.name) {
            @if (action?.canDo?.()) {
              <button
                class="action-button"
                mat-icon-button
                (click)="dispatchAction.emit({ name: $safeNavigationMigration(action?.name?.()), value: $safeNavigationMigration(message().id?.()) })"
              >
                <mat-icon class="action-icon">{{ action?.icon?.() }}</mat-icon>
              </button>
            }
          }
        </div>
      }
    }
  </div>
</div>
